<template>
  <v-row dense>
    <v-col cols="12">
      <v-banner density="compact" bg-color="grey-darken-4" class="pa-2 pt-0">
        <template v-slot:text>
          <div id="funcComments" class="text-light-green-darken-2">
            {{ $t("strings.code-editor-function-comment") }}
            {{ functionArgsComment }}
          </div>
          <div id="funcStart" class="text-blue-lighten-1">
            function
            <span class="text-yellow-darken-1">
              (
              <span id="funcArgs" class="text-grey-lighten-3">
                {{ functionArgsString }}
              </span>
              ) {
            </span>
          </div>
        </template>
      </v-banner>
      <div
        id="codeEditor"
        ref="codeEditor"
        :style="{ height: editorHeight, minHeight: '200px' }"
      ></div>
      <v-banner
        lines="one"
        density="compact"
        bg-color="grey-darken-4"
        class="text-yellow-darken-1 px-2"
        text="}"
      >
      </v-banner>
    </v-col>
  </v-row>
</template>

<script>
import { inject, ref, onMounted, watch, computed } from "vue";
import * as monaco from "monaco-editor/editor/editor.api.js";
import { encodeBase64, decodeBase64 } from "@/mixins/common-utils.js";

export default {
  props: ["snippetContentHeight", "snippetSources"],
  setup(props) {
    const valid = inject("valid");
    valid.value = true;
    const codeEditor = ref();
    let editorInstance = null;
    let editorHeight = ref(props.snippetContentHeight + "px");

    const formData = inject("formData");
    const codeSources = computed(() => {
      return props.snippetSources;
    });

    //Creates the description of the variable assignment to be put in the comment to the function
    const functionArgsComment = computed(() => {
      let text = "";
      for (let i = 0; i < codeSources.value.length; i++) {
        text += `s${i + 1}=${codeSources.value[i].id}, `;
      }
      //Removes the last comma and space
      return text.slice(0, -2);
    });
    //Creates the list of parameters for the function
    const functionArgsString = computed(() => {
      let text = "";
      for (let i = 0; i < codeSources.value.length; i++) {
        text += `s${i + 1}, `;
      }
      //Removes the last comma and space
      return text.slice(0, -2);
    });

    onMounted(() => {
      editorInstance = monaco.editor.create(codeEditor.value, {
        value: formData.snippetCode
          ? decodeBase64(formData.snippetCode)
          : "return 'something';",
        language: "javascript",
        lineNumbers: "on",
        roundedSelection: false,
        scrollBeyondLastLine: false,
        readOnly: false,
        theme: "vs-dark",
        automaticLayout: true,
      });

      //Add a listener for the onDidChangeModelContent event (every code change)
      editorInstance.onDidChangeModelContent(() => {
        formData.snippetCode = encodeBase64(editorInstance.getValue());
      });

      //Initialize snippetCode on formData
      formData.snippetCode = encodeBase64(editorInstance.getValue());
    });

    watch(
      () => props.snippetContentHeight,
      (newValue) => {
        editorHeight.value = newValue + "px";
      },
    );

    return {
      codeEditor,
      formData,
      editorHeight,
      functionArgsComment,
      functionArgsString,
    };
  },
};
</script>
